"use client";

import { useEffect, useState } from "react";
import { apiClient } from "@/lib/api-client";
import { useQueryParam } from "@/lib/use-query-param";
import type { ResultEvent } from "@/types/event";
import type { RaceResult } from "@/types/result";
import type { MessagingProject } from "@/types/project";

export default function PublicResultViewPage() {
  const eventSlug = useQueryParam("eventSlug");
  const resultId = useQueryParam("resultId");
  const [data, setData] = useState<{ project: MessagingProject; event: ResultEvent; result: RaceResult } | null>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!eventSlug || !resultId) return;
    apiClient<{ project: MessagingProject; event: ResultEvent; result: RaceResult }>(`/api/public/results/${eventSlug}/${resultId}`)
      .then(setData)
      .catch((err) => setError(err instanceof Error ? err.message : "Result not found"));
  }, [eventSlug, resultId]);

  if (error) return <main className="mx-auto max-w-2xl px-4 py-10 text-sm text-red-700">{error}</main>;
  if (!data) return <main className="mx-auto max-w-2xl px-4 py-10 text-sm text-muted">Loading result...</main>;

  const { event, result } = data;
  return (
    <main className="mx-auto max-w-2xl px-4 py-10">
      <section className="rounded-card border border-line bg-white p-6">
        <p className="text-sm text-muted">{event.name}</p>
        <h1 className="mt-2 text-2xl font-semibold text-ink">{result.runner_name}</h1>
        <div className="mt-6 grid gap-4 sm:grid-cols-2">
          <div><p className="text-sm text-muted">BIB</p><p className="font-semibold">{result.bib_number || "-"}</p></div>
          <div><p className="text-sm text-muted">Category</p><p className="font-semibold">{result.category || "-"}</p></div>
          <div><p className="text-sm text-muted">Finish Time</p><p className="font-semibold">{result.finish_time}</p></div>
          <div><p className="text-sm text-muted">Rank</p><p className="font-semibold">{result.rank || "-"}</p></div>
        </div>
      </section>
    </main>
  );
}
